import Card from 'components/card';
import LoadingTableLine from './loadingTableLine';
import { MdFileDownload } from 'react-icons/md';

const VolumeTable = (props: { data: any; startDate?: string; endDate?: string }) => {
    const { data, startDate, endDate } = props;

    const sortedData = data
        ? [...data].sort((a: any, b: any) =>
              (a.name || '').localeCompare(b.name || '', 'fr', { sensitivity: 'base' })
          )
        : data;

    const formatDateForFilename = (dateStr: string) => {
        if (!dateStr) return '';
        const [year, month, day] = dateStr.split('-');
        return `${day}-${month}-${year}`;
    };

    const exportToCSV = () => {
        if (!data || data.length === 0) return;

        // En-têtes du CSV
        const headers = ['Produit', 'Quantité', 'Unité', 'Prix total'];
        
        // Lignes de données
        const rows = sortedData.map((item: any) => [
            item.name || 'N/A',
            item.sum || '0',
            item.unity || '',
            item.totalPrice || '0'
        ]);

        // Construction du CSV
        const csvContent = [
            headers.join(';'),
            ...rows.map((row: any[]) => row.join(';'))
        ].join('\n');

        // Ajout du BOM pour l'encodage UTF-8 (pour Excel)
        const BOM = '\uFEFF';
        const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });

        // Nom du fichier avec les dates
        const start = formatDateForFilename(startDate || '');
        const end = formatDateForFilename(endDate || '');
        const filename = `volume-produits-du-${start}-au-${end}.csv`;

        // Téléchargement
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <Card
            extra={
                'w-full pb-[10px] pt-[10px] px-[29px] h-fit bg-blue-200 shadow shadow-3xl border'
            }
        >
            <div className="flex justify-between items-center mb-2">
                <p className="text-lg font-bold text-navy-700 dark:text-white">
                    Volume par produit sur la période
                </p>
                {data && data.length > 0 && (
                    <button
                        onClick={exportToCSV}
                        className="flex items-center gap-1 px-3 py-1.5 text-sm font-medium text-white bg-[#0260CB] rounded-lg hover:bg-[#01499b] active:bg-[#024086] transition duration-200"
                        title="Exporter en CSV"
                    >
                        <MdFileDownload className="h-4 w-4" />
                        <span className="hidden sm:inline">Export CSV</span>
                    </button>
                )}
            </div>
            {data ? (
                data.length > 0 ? (
                    <table className="w-full">
                        <thead>
                            <tr className="text-left h-[24px]">
                                <th
                                    className="pl-[10px] w-[50%] sm:w-[35%] text-xs sm:text-sm text-gray-600 dark:text-white font-medium border-b border-[#E9EDF7] align-bottom"
                                    rowSpan={2}
                                >
                                    Produit
                                </th>
                                <th
                                    className="hidden sm:table-cell pl-[10px] w-[15%] text-xs sm:text-sm text-gray-600 dark:text-white font-medium border-b border-[#E9EDF7] align-bottom"
                                    rowSpan={2}
                                >
                                    Quantité
                                </th>
                                <th
                                    className="hidden sm:table-cell pl-[10px] w-[15%] text-xs sm:text-sm text-gray-600 dark:text-white font-medium border-b border-[#E9EDF7] align-bottom"
                                    rowSpan={2}
                                >
                                    Prix total
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {sortedData.map((data: any, index: number) => {
                                return (
                                    <tr key={index} className="text-left h-[24px] border-t border-[#E9EDF7] sm:border-none">
                                        <td className="text-sm font-medium pl-[10px] text-toola-800">
                                            {data.name
                                                ? data.name.toLowerCase()
                                                : 'N/A'}
                                            <div className="sm:hidden font-normal">
                                                {data.sum + ' ' + data.unity}
                                                <br />
                                                {data.totalPrice}€
                                            </div>
                                        </td>
                                        <td className="text-sm font-medium hidden sm:table-cell pl-[10px] text-toola-800">
                                            {data.sum + ' ' + data.unity}
                                        </td>
                                        <td className="text-sm font-medium hidden sm:table-cell pl-[10px] text-toola-800">
                                            {data.totalPrice} €
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                ) : (
                    <div className="w-full flex items-center justify-center h-[50px]">
                        <p className="text-gray-700">
                            Aucun produit à livrer pour cette date
                        </p>
                    </div>
                )
            ) : (
                <div>
                    <table className="w-full">
                        <thead>
                            <tr className="text-left h-[24px]">
                                <th
                                    className="pl-[10px] w-[50%] sm:w-[35%] text-xs sm:text-sm text-gray-600 dark:text-white font-medium border-b border-[#E9EDF7] align-bottom"
                                    rowSpan={2}
                                >
                                    Produit
                                </th>
                                <th
                                    className="hidden sm:table-cell pl-[10px] w-[15%] text-xs sm:text-sm text-gray-600 dark:text-white font-medium border-b border-[#E9EDF7] align-bottom"
                                    rowSpan={2}
                                >
                                    Quantité
                                </th>
                                <th
                                    className="hidden sm:table-cell pl-[10px] w-[15%] text-xs sm:text-sm text-gray-600 dark:text-white font-medium border-b border-[#E9EDF7] align-bottom"
                                    rowSpan={2}
                                >
                                    Prix total
                                </th>
                                <th
                                    className="w-[50%] sm:w-[35%] text-xs sm:text-sm text-gray-600 dark:text-white font-medium text-center"
                                    colSpan={3}
                                >
                                    Fluctuations
                                </th>
                            </tr>
                            <tr>
                                <th className="text-xs sm:text-sm text-gray-600 dark:text-white font-medium border-b border-[#E9EDF7]">
                                    Jour
                                </th>
                                <th className="text-xs sm:text-sm text-gray-600 dark:text-white font-medium border-b border-[#E9EDF7]">
                                    Semaine
                                </th>
                                <th className="text-xs sm:text-sm text-gray-600 dark:text-white font-medium border-b border-[#E9EDF7]">
                                    Mois
                                </th>
                            </tr>
                        </thead>
                    </table>
                    <div className="w-full">
                        {Array(5).fill(0).map((_, index) => <LoadingTableLine key={index} />)}
                    </div>
                </div>
            )}
        </Card>
    );
};

export default VolumeTable;